import { images } from "../../../constants";

const TopNavigation = () => {
  return (
    <div className={`w-full h-12 relative px-4 bg-black py-[6px] justify-start flex items-center`}>
      <img className="w-[120px]" src={images?.logo} alt="logo" />
    </div>
  );
};
export default TopNavigation;
